var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBillable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 14.25,
    height: 14.25,
    rx: 7.125,
    fill: "#1A7D45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90257 8.59731C9.90257 9.05657 9.71838 9.43648 9.35001 9.73703C8.98164 10.0342 8.46701 10.2216 7.80611 10.2993V11.4745H7.10729V10.3449C6.70281 10.3449 6.31096 10.3162 5.93176 10.2588C5.55255 10.198 5.24197 10.1152 5 10.0106V9.22036C5.29975 9.3453 5.64465 9.4483 6.03469 9.52935C6.42834 9.60702 6.78587 9.64585 7.10729 9.64585V7.41706C6.36694 7.19756 5.84689 6.9426 5.54714 6.65218C5.251 6.36176 5.10293 5.98692 5.10293 5.52765C5.10293 5.08527 5.28531 4.72225 5.65006 4.43858C6.01843 4.15492 6.50418 3.98269 7.10729 3.92191V3H7.80611V3.91178C8.47062 3.92866 9.11166 4.05361 9.72922 4.28662L9.44752 4.95019C8.90942 4.75095 8.36228 4.63276 7.80611 4.59561V6.79401C8.37311 6.96286 8.79746 7.12833 9.07915 7.29042C9.36085 7.44914 9.56851 7.63319 9.70213 7.84256C9.83576 8.04855 9.90257 8.30013 9.90257 8.59731ZM8.98164 8.66316C8.98164 8.42002 8.90039 8.22415 8.73787 8.07557C8.57897 7.9236 8.26838 7.77333 7.80611 7.62474V9.5952C8.5898 9.49389 8.98164 9.18321 8.98164 8.66316ZM6.01843 5.51752C6.01843 5.77417 6.09969 5.98016 6.26221 6.1355C6.42472 6.29084 6.70642 6.43774 7.10729 6.5762V4.61587C6.74976 4.66991 6.4789 4.77628 6.29471 4.935C6.11053 5.09034 6.01843 5.28451 6.01843 5.51752Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 14.25,
    height: 14.25,
    rx: 7.125,
    stroke: "#1A7D45",
    strokeWidth: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillable);
export default __webpack_public_path__ + "static/media/billable.acc80cc1959a2da1bb9b4d75da740729.svg";
export { ForwardRef as ReactComponent };